import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AppProvider } from "@/context/AppContext";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import About from "@/components/About";
import Academy from "@/components/Academy";
import DIY from "@/components/DIY";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppFab from "@/components/WhatsAppFab";

function HomePage() {
  return (
    <div className="App min-h-screen" style={{ backgroundColor: "var(--ht-bg)" }}>
      <Header />
      <main>
        <Hero />
        <Services />
        <About />
        <Academy />
        <DIY />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFab />
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "var(--ht-surface)",
            color: "var(--ht-text)",
            border: "1px solid var(--ht-border)",
          },
        }}
      />
    </div>
  );
}

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
